import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

export const PopoverButton = ({
  badgeText,
  ...props
}: { badgeText?: string } & ComponentProps<"button">) => (
  <button
    {...props}
    className={twMerge(
      "block w-full px-4 py-2 text-start text-sm text-gray-700 hover:bg-gray-100",
      props.className,
      badgeText && "flex items-center gap-x-2"
    )}
  >
    {props.children}
    {badgeText && (
      <span className="rounded-3xl border border-yellow-200 bg-yellow-100 px-2 py-px text-xs font-medium text-yellow-600">
        {badgeText}
      </span>
    )}
  </button>
);
